import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Angulartics2Module } from 'angulartics2';

import {
  CollapseToggleModule,
  CommonRadioGroupModule,
  DropdownFilterModule,
  FormValidationModule,
  SearchBarModule,
  SortableColumnModule,
  UtilsModule,
} from '@tablesready/common-ui';
import { SubscriptionStateModule } from '@tablesready/frontend-subscription-state';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { AuthModule } from '@tablesready/frontend-auth';
import { AlertsModule, ClockModule } from '@tablesready/frontend-alerts-bar';
import { StatusModule } from '@tablesready/frontend-status-bar';
import { FrontendModalModule } from '@tablesready/frontend-modal';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { SmsUsageModule } from '../../components';
import { BillingComponent } from './billing.component';
import {
  AccountBillingComponent,
  OfflineLocationsComponent,
  ApplyDiscountCodeComponent,
} from './account-billing';
import { InvoicesComponent } from './components/invoices/invoices.component';
import { FreePlanComponent } from './components/free-plan/free-plan.component';
import { PaymentPlanComponent } from './components/payment-plan/payment-plan.component';
import {
  CancelSubscriptionComponent,
  PauseSubscriptionComponent,
  ReactivateSubscriptionComponent,
  UpdateBillingComponent,
} from './modals';
import { BillingService } from './services';

@NgModule({
  declarations: [
    AccountBillingComponent,
    BillingComponent,
    UpdateBillingComponent,
    InvoicesComponent,
    FreePlanComponent,
    PaymentPlanComponent,
    CancelSubscriptionComponent,
    PauseSubscriptionComponent,
    ReactivateSubscriptionComponent,
    OfflineLocationsComponent,
    ApplyDiscountCodeComponent,
  ],
  imports: [
    NgbModule,
    SortableColumnModule,
    CommonRadioGroupModule,
    FrontendIconsModule,
    CommonModule,
    SearchBarModule,
    ReactiveFormsModule,
    CollapseToggleModule,
    DropdownFilterModule,
    FormsModule,
    AuthModule,
    AlertsModule,
    ClockModule,
    StatusModule,
    FormValidationModule,
    Angulartics2Module,
    UtilsModule,
    SmsUsageModule,
    SubscriptionStateModule,
    FrontendModalModule,
    FrontendPullRefreshModule,
    FrontendDropdownModule,
  ],
  providers: [CurrencyPipe, BillingService],
})
export class BillingModule {}
